import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Element from 'element-ui'

Vue.use(VueI18n)

function loadLocaleMessages() {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const eleLocales = require.context('element-ui/lib/locale/lang', false, /(en|zh-CN|zh-TW|ko|ja)+\.js$/i)
  const messages = {}
  const eleMessages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  eleLocales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      eleMessages[locale] = eleLocales(key).default
    }
  })
  return {
    en: {
      ...eleMessages.en,
      ...messages.en
    },
    cn: {
      ...eleMessages['zh-CN'],
      ...messages['zh-CN']
    },
    tc: {
      ...eleMessages['zh-TW'],
      ...messages['zh-TW']
    },
    jap: {
      ...eleMessages.ja,
      ...messages.ja
    },
    ko: {
      ...eleMessages.ko,
      ...messages.ko
    }
  }
}

const dateTimeFormats = {
  'en-GB': {
    short: {
      year: 'numeric', month: 'long', day: 'numeric'
    },
    long: {
      year: 'numeric', month: 'short', day: 'numeric',
      weekday: 'short', hour: 'numeric', minute: 'numeric'
    }
  },
  'zh-CN': {
    short: {
      year: 'numeric', month: 'long', day: 'numeric'
    },
    long: {
      year: 'numeric', month: 'short', day: 'numeric',
      weekday: 'short', hour: 'numeric', minute: 'numeric'
    }
  },
  'zh-HK': {
    short: {
      year: 'numeric', month: 'long', day: 'numeric'
    },
    long: {
      year: 'numeric', month: 'short', day: 'numeric',
      weekday: 'short', hour: 'numeric', minute: 'numeric'
    }
  },
  'ko': {
    short: {
      year: 'numeric', month: 'long', day: 'numeric'
    },
    long: {
      year: 'numeric', month: 'short', day: 'numeric',
      weekday: 'short', hour: 'numeric', minute: 'numeric'
    }
  },
  'ja-JP': {
    short: {
      year: 'numeric', month: 'short', day: 'numeric'
    },
    long: {
      year: 'numeric', month: 'short', day: 'numeric',
      weekday: 'short', hour: 'numeric', minute: 'numeric', hour12: true
    }
  }
}

const i18n = new VueI18n({
  locale: localStorage.getItem('lang') || process.env.VUE_APP_I18N_LOCALE,
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE,
  messages: loadLocaleMessages(),
  dateTimeFormats
})

Vue.use(Element, {
  i18n: (key, value) => i18n.t(key, value)
})

export default i18n
